import { FunctionComponent } from 'react'
import AudienceAnalysis from '@/components/kol/detail/audience-analyses/audience-analysis'
import AudienceAuthenticity from '@/components/kol/detail/audience-analyses/audience-authenticity'
import useAudienceAnalyze from '@/components/kol/hooks/use-audience-analyze'
import useKolDetailRoute from '@/components/kol/hooks/use-kol-detail-route'
import { Page } from '@/hooks/use-authorization/constants'
import useIsPublicDetailPage from '@/hooks/use-is-public-detail-page'
import { KolSchemaModel } from '@/types/schema/kol-schema'
import { Platform, PlatformCode } from '@/utils/convert-platform'

interface AudienceAnalysesProps {
  platform: Platform
  kolInfo?: KolSchemaModel
  isFetchingKolInfo: boolean
  isKolInfoLocked: boolean
  showMockData?: boolean
}

const AudienceAnalyses: FunctionComponent<AudienceAnalysesProps> = ({
  platform,
  kolInfo,
  isFetchingKolInfo,
  isKolInfoLocked,
  showMockData,
}) => {
  const { page } = useKolDetailRoute()
  const { audienceAnalyze, isFetching: isFetchingAudienceAnalyze } =
    useAudienceAnalyze({
      kolId: kolInfo?.id,
      kolDcIdHashed: kolInfo?.dcIdHashed,
      platform: platform.code,
      isFetchingKolInfo,
      isLocked: isKolInfoLocked,
    })
  const isPublicDetailPage = useIsPublicDetailPage()
  const displayAuthenticity =
    [Page.KolId, Page.PublicKolDetail].includes(page) &&
    PlatformCode.Instagram === platform.code

  return (
    <>
      <AudienceAnalysis
        audienceData={audienceAnalyze}
        isFetchingAudienceAnalyze={isFetchingAudienceAnalyze}
        isFetchingKolInfo={isFetchingKolInfo}
        isLocked={isKolInfoLocked}
        isPublicDetailPage={isPublicDetailPage}
        kolInfo={kolInfo}
        platform={platform}
        showMockData={showMockData}
      />
      {displayAuthenticity && (
        <AudienceAuthenticity
          authenticity={audienceAnalyze?.authenticity}
          isFetching={isFetchingAudienceAnalyze}
          isLocked={isKolInfoLocked}
          isPublicDetailPage={isPublicDetailPage}
          kolInfo={kolInfo}
          platform={platform}
          showMockData={showMockData}
        />
      )}
    </>
  )
}

export default AudienceAnalyses
